import React, { useState, useEffect } from 'react';
import './Blog.css';
import { db } from '../../config/firebase'; // Ensure the import path
import { collection, getDocs } from 'firebase/firestore';
import { BiUserCircle, BiArrowToRight } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const Blog = () => {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        const fetchPosts = async () => {
            const querySnapshot = await getDocs(collection(db, 'posts'));
            const postsList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPosts(postsList);
        };

        fetchPosts();
    }, []);

    const truncateMessage = (message, length) => {
        if (message.length <= length) {
            return message;
        }
        return message.slice(0, length) + '...';
    };

    return (
        <div className='posts'>
            {posts.length > 0 ? (
                posts.map((post) => (
                    <div className="post" key={post.id}>
                        <img className='postImg' src={post.imageUrl} alt={post.title} />
                        <Link to={`/blog/post/${post.id}`}><BiArrowToRight className='read' /></Link>
                        <div className="postsinfo">
                            <BiUserCircle className='user' />
                            <div className="postcast">
                                <span className="postcast">Author: <b>{post.author}</b></span>
                            </div>
                            <span className='postsTitle'>{post.title}</span>
                            <hr />
                            <span className="postDate">{new Date(post.uploadedAt.seconds * 1000).toLocaleDateString()}</span>
                        </div>
                        <p className="describ">{truncateMessage(post.message, 100)}</p>
                    </div>
                ))
            ) : (
                <div className='no_posts'>
                    <p>No posts available</p>
                </div>
            )}
        </div>
    );
};

export default Blog;
